import { Navigate, Route } from 'react-router-dom-v5-compat';

// @ts-expect-error - no TypeScript definitions yet
import AcceptInvitePage from './views/AcceptInvitePage';
// @ts-expect-error - no TypeScript definitions yet
import { MagicLinkCallback } from './views/MagicLinkCallback';
// @ts-expect-error - no TypeScript definitions yet
import OAuthCallback from './views/OAuthCallback';
// @ts-expect-error - no TypeScript definitions yet
import { PublicRoute } from './views/PublicRoute';
// @ts-expect-error - no TypeScript definitions yet
import ResetPasswordPage from './views/ResetPasswordPage';
// @ts-expect-error - no TypeScript definitions yet
import { SharedPage } from './views/SharedPage';
// @ts-expect-error - no TypeScript definitions yet
import SignInPage from './views/SignInPage';
// @ts-expect-error - no TypeScript definitions yet
import SignUpPage from './views/SignUpPage';
// @ts-expect-error - no TypeScript definitions yet
import VerifyEmailCallback from './views/VerifyEmailCallback';
import { ROUTES } from './routes';

/**
 * The routes that sign a person in or out, accept an invite and open a public shared page. A full
 * user's and a reviewer's route trees both include them.
 */
export const renderAccountPublicRoutes = () => (
  <>
    <Route
      path={ROUTES.SIGN_UP}
      element={
        <PublicRoute>
          <SignUpPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.SIGN_UP_DEPRECATED}
      element={
        <Navigate
          to={ROUTES.SIGN_UP}
          replace
        />
      }
    />

    <Route
      path={ROUTES.SIGN_IN}
      element={
        <PublicRoute>
          <SignInPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.SIGN_IN_DEPRECATED}
      element={
        <Navigate
          to={ROUTES.SIGN_IN}
          replace
        />
      }
    />

    <Route
      path={ROUTES.RESET_PASSWORD}
      element={
        <PublicRoute displayNavigation>
          <ResetPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.ACCEPT_INVITE}
      element={
        <PublicRoute>
          <AcceptInvitePage />
        </PublicRoute>
      }
    />

    {[ROUTES.OAUTH_CALLBACK, ROUTES.SAML_CALLBACK].map((path) => (
      <Route
        key={path}
        path={path}
        element={
          <PublicRoute displayNavigation>
            <OAuthCallback />
          </PublicRoute>
        }
      />
    ))}
    <Route
      path={ROUTES.VERIFY_EMAIL_CALLBACK}
      element={
        <PublicRoute displayNavigation>
          <VerifyEmailCallback />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.MAGIC_LINK_CALLBACK}
      element={
        <PublicRoute displayNavigation>
          <MagicLinkCallback />
        </PublicRoute>
      }
    />
    <Route
      path={`${ROUTES.SHARED}/:shareDocumentId`}
      element={
        <PublicRoute>
          <SharedPage />
        </PublicRoute>
      }
    />
  </>
);
